import React from "react";
import {Radio} from 'antd';
import {RobotOutlined} from '@ant-design/icons'
import * as S from "./ChatQuestion.styles"


interface Props {
    setAnswer: (answer: string) => void,
    question: {
        question_text: string,
        question_answers: { value: string, label: string }[]
    }[]
}

const ChatQuestion = ({setAnswer, question}: Props) => {


    return (
        <S.QuestionCard title={
            <S.CardHeader>
                <span> <RobotOutlined/> VA says:</span>
            </S.CardHeader>
        }>

            <span>Welcome to the Virtual Assistant. Please, select one of the options bellow.</span>
            {question.map((q) => {
                return (
                    <>
                        <span>{q.question_text}</span>
                        <Radio.Group onChange={(event) => {
                            setAnswer(event.target.value)
                        }}>
                            {q.question_answers.map((a) => {
                                return (
                                    <Radio value={a.value}>
                                        {a.label}
                                    </Radio>
                                )
                            })}
                        </Radio.Group>
                    </>
                )
            })}

        </S.QuestionCard>
    )
}

export default ChatQuestion;
